export const onIdle = (callback: () => void | Promise<void>) => {
  const supportIdleCallback = 'requestIdleCallback' in window

  if (supportIdleCallback) {
    requestIdleCallback(callback)
  }

  if (!supportIdleCallback) {
    setTimeout(callback, 500)
  }
}
